/*global document, window */
import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import { Link } from 'react-scroll';

class Header extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            open: false,
            scrolledUp: false
        };
    }

    componentDidMount() {
        this.documentElement = window.document.documentElement;
        window.addEventListener('scroll', this.checkScroll);
    }

    checkScroll = () => {
        var top =
            (window.pageYOffset || this.documentElement.scrollTop) -
            (this.documentElement.clientTop || 0);
        if (top > 0 && !this.state.scrolledUp) {
            this.setState({
                scrolledUp: true
            });
        }

        if (top === 0) {
            this.setState({
                scrolledUp: false
            });
        }
    };

    toggleMenu = () => {
        this.setState({
            open: !this.state.open
        });
    };

    setWindowHash = (hash, closeMenu=false) => {
        if (window.history.pushState) {
            window.history.pushState(null, null, `#${hash}`);
        }

        if (closeMenu) {
            this.toggleMenu();
        }
    };

    render() {
        const headerClassNames = classnames('header z-50 flex items-start', {
            'header--expanded': this.state.open,
            'header--scrolled-up': this.state.scrolledUp
        });

        return (
            <header className={headerClassNames}>
                <div className="container container--plus flex justify-between items-center py-5">
                    <a href="/" className="flex">
                        <svg height="44" viewBox="0 0 573 173" fill-rule="evenodd" clip-rule="evenodd" stroke-linejoin="round" stroke-miterlimit="1.414"><g fill="#564c3a" fill-rule="nonzero"><path d="M214.849 117.38c-1.239 0-2.263-.413-3.071-1.24-.808-.827-1.212-1.853-1.212-3.08V68.1c0-1.28.418-2.333 1.253-3.16s1.899-1.24 3.191-1.24h14.948c3.556 0 6.707.667 9.454 2 2.747 1.333 4.875 3.227 6.383 5.68s2.263 5.28 2.263 8.48c0 3.147-.755 5.96-2.263 8.44-1.508 2.48-3.636 4.4-6.383 5.76-2.747 1.36-5.898 2.04-9.454 2.04h-10.827v16.96c0 1.227-.404 2.253-1.212 3.08-.808.827-1.831 1.24-3.07 1.24zm15.029-28.8c2.908 0 5.198-.773 6.868-2.32 1.669-1.547 2.504-3.653 2.504-6.32 0-2.667-.835-4.787-2.504-6.36-1.67-1.573-3.96-2.36-6.868-2.36h-10.747v17.36h10.747zM261.39 117.38c-1.239 0-2.263-.359-3.071-1.078-.808-.718-1.212-1.611-1.212-2.677v-46.17c0-1.066.404-1.959 1.212-2.677.808-.719 1.832-1.078 3.071-1.078 1.185 0 2.181.359 2.989 1.078.808.718 1.212 1.611 1.212 2.677v46.17c0 1.066-.404 1.959-1.212 2.677-.808.719-1.804 1.078-2.989 1.078zM294.841 117.38c-3.394 0-6.41-.733-9.05-2.2-2.639-1.467-4.686-3.52-6.141-6.16-1.454-2.64-2.181-5.64-2.181-9V80.66c0-1.227.404-2.253 1.212-3.08.808-.827 1.804-1.24 2.989-1.24 1.185 0 2.182.413 2.99 1.24.808.827 1.212 1.853 1.212 3.08v20c0 2.613.835 4.76 2.505 6.44 1.67 1.68 3.824 2.52 6.464 2.52 2.532 0 4.619-.84 6.262-2.52 1.643-1.68 2.464-3.827 2.464-6.44v-20c0-1.227.404-2.253 1.212-3.08.808-.827 1.832-1.24 3.071-1.24 1.185 0 2.181.413 2.989 1.24.808.827 1.212 1.853 1.212 3.08v19.36c0 3.36-.727 6.36-2.181 9-1.455 2.64-3.488 4.693-6.101 6.16-2.612 1.467-5.588 2.2-8.928 2.2zM336.21 117.38c-2.962 0-5.683-.547-8.16-1.64-2.478-1.093-4.606-2.573-6.384-4.44-.808-.747-1.212-1.653-1.212-2.72 0-1.013.377-1.88 1.132-2.6.754-.72 1.643-1.08 2.666-1.08.97 0 1.858.373 2.666 1.12 2.963 2.72 6.06 4.08 9.292 4.08 1.832 0 3.354-.373 4.566-1.12 1.212-.747 1.818-1.84 1.818-3.28 0-1.173-.445-2.08-1.334-2.72-.888-.64-2.302-1.36-4.242-2.16l-4.04-1.68c-3.501-1.44-6.1-3.013-7.797-4.72-1.697-1.707-2.545-3.947-2.545-6.72 0-3.52 1.32-6.293 3.959-8.32 2.64-2.027 5.979-3.04 10.019-3.04 2.478 0 4.808.427 6.99 1.28 2.181.853 4.053 2.027 5.615 3.52.862.8 1.293 1.733 1.293 2.8 0 1.013-.35 1.867-1.05 2.56-.701.693-1.536 1.04-2.505 1.04-.7 0-1.589-.4-2.667-1.2-2.37-1.813-4.982-2.72-7.837-2.72-1.67 0-2.99.32-3.959.96-.97.64-1.455 1.573-1.455 2.8 0 1.013.391 1.853 1.172 2.52.781.667 2.141 1.373 4.08 2.12l3.798 1.52c3.77 1.547 6.518 3.213 8.241 5 1.724 1.787 2.586 4.067 2.586 6.84 0 3.787-1.401 6.733-4.202 8.84s-6.302 3.16-10.504 3.16z"/><g><path d="M415.986 63.82c1.185 0 2.169.413 2.95 1.24.781.827 1.171 1.853 1.171 3.08v44.92c0 1.227-.404 2.253-1.212 3.08-.808.827-1.831 1.24-3.07 1.24-1.239 0-2.263-.413-3.071-1.24-.808-.827-1.212-1.853-1.212-3.08V80.9l-12.443 19.36c-.646 1.013-1.306 1.733-1.979 2.16-.674.427-1.441.64-2.303.64-.916 0-1.71-.213-2.384-.64-.673-.427-1.306-1.147-1.899-2.16L378.091 80.9v32.16c0 1.227-.404 2.253-1.212 3.08-.808.827-1.831 1.24-3.07 1.24-1.239 0-2.263-.413-3.071-1.24-.808-.827-1.212-1.853-1.212-3.08V68.14c0-1.227.391-2.253 1.172-3.08.781-.827 1.764-1.24 2.949-1.24.97 0 1.791.253 2.465.76.673.507 1.414 1.4 2.222 2.68l16.483 25.6 16.483-25.6c.808-1.28 1.549-2.173 2.222-2.68.673-.507 1.495-.76 2.464-.76zM436.837 58.14c1.562 0 2.895.533 3.999 1.6 1.105 1.067 1.657 2.347 1.657 3.84 0 1.493-.552 2.773-1.657 3.84-1.104 1.067-2.437 1.6-3.999 1.6-1.562 0-2.896-.533-4-1.6-1.104-1.067-1.656-2.347-1.656-3.84 0-1.493.552-2.773 1.656-3.84 1.104-1.067 2.438-1.6 4-1.6zm-.081 59.24c-1.185 0-2.182-.413-2.99-1.24-.808-.827-1.212-1.853-1.212-3.08v-32.4c0-1.227.404-2.253 1.212-3.08.808-.827 1.832-1.24 3.071-1.24 1.185 0 2.181.413 2.989 1.24.808.827 1.212 1.853 1.212 3.08v32.4c0 1.227-.404 2.253-1.212 3.08-.808.827-1.831 1.24-3.07 1.24zM473.116 76.34c4.525 0 8.134 1.413 10.827 4.24 2.694 2.827 4.04 6.613 4.04 11.36v21.12c0 1.28-.404 2.32-1.212 3.12-.808.8-1.804 1.2-2.989 1.2-1.239 0-2.263-.413-3.071-1.24-.808-.827-1.212-1.853-1.212-3.08v-20c0-2.72-.794-4.92-2.383-6.6-1.589-1.68-3.677-2.52-6.262-2.52-2.64 0-4.808.853-6.505 2.56s-2.545 3.893-2.545 6.56v20c0 1.28-.391 2.32-1.172 3.12-.781.8-1.791 1.2-3.03 1.2-1.239 0-2.262-.413-3.07-1.24-.808-.827-1.212-1.853-1.212-3.08v-32.4c0-1.227.404-2.253 1.212-3.08.808-.827 1.831-1.24 3.07-1.24 1.185 0 2.169.413 2.95 1.24.781.827 1.171 1.853 1.171 3.08 1.455-1.387 3.151-2.453 5.091-3.2 1.939-.747 4.04-1.12 6.302-1.12zM516.748 117.38c-3.394 0-6.41-.733-9.05-2.2-2.639-1.467-4.686-3.52-6.14-6.16-1.455-2.64-2.182-5.64-2.182-9V80.66c0-1.227.404-2.253 1.212-3.08.808-.827 1.805-1.24 2.99-1.24 1.185 0 2.181.413 2.989 1.24.808.827 1.212 1.853 1.212 3.08v20c0 2.613.835 4.76 2.505 6.44 1.67 1.68 3.825 2.52 6.464 2.52 2.532 0 4.619-.84 6.262-2.52 1.643-1.68 2.464-3.827 2.464-6.44v-20c0-1.227.404-2.253 1.212-3.08.808-.827 1.832-1.24 3.071-1.24 1.185 0 2.181.413 2.989 1.24.808.827 1.212 1.853 1.212 3.08v19.36c0 3.36-.727 6.36-2.181 9-1.455 2.64-3.488 4.693-6.101 6.16-2.612 1.467-5.588 2.2-8.928 2.2zM558.118 117.38c-2.963 0-5.683-.547-8.161-1.64-2.478-1.093-4.606-2.573-6.383-4.44-.808-.747-1.212-1.653-1.212-2.72 0-1.013.377-1.88 1.131-2.6.754-.72 1.643-1.08 2.666-1.08.97 0 1.859.373 2.667 1.12 2.962 2.72 6.06 4.08 9.292 4.08 1.831 0 3.353-.373 4.565-1.12 1.212-.747 1.818-1.84 1.818-3.28 0-1.173-.445-2.08-1.333-2.72-.889-.64-2.303-1.36-4.242-2.16l-4.04-1.68c-3.502-1.44-6.101-3.013-7.798-4.72-1.696-1.707-2.545-3.947-2.545-6.72 0-3.52 1.32-6.293 3.959-8.32 2.64-2.027 5.98-3.04 10.02-3.04 2.477 0 4.807.427 6.989 1.28 2.181.853 4.053 2.027 5.615 3.52.862.8 1.293 1.733 1.293 2.8 0 1.013-.35 1.867-1.05 2.56-.7.693-1.535 1.04-2.505 1.04-.7 0-1.589-.4-2.666-1.2-2.371-1.813-4.983-2.72-7.838-2.72-1.67 0-2.99.32-3.959.96-.97.64-1.455 1.573-1.455 2.8 0 1.013.391 1.853 1.172 2.52.781.667 2.141 1.373 4.08 2.12l3.798 1.52c3.771 1.547 6.518 3.213 8.242 5 1.723 1.787 2.585 4.067 2.585 6.84 0 3.787-1.4 6.733-4.201 8.84-2.801 2.107-6.303 3.16-10.504 3.16z"/></g></g><path d="M166.899 25.43c0-13.759-11.171-24.93-24.93-24.93H25.627C11.868.5.697 11.671.697 25.43v122.14c0 13.759 11.171 24.93 24.93 24.93h116.342c13.759 0 24.93-11.171 24.93-24.93V25.43z" fill="url(#_Linear1)"/><path d="M49.016 43.505c.891.058 1.18.162 1.695.376 1.831.758 3.036 2.312 3.087 4.619v24c-.108 4.959-9.836 7.55-10 0v-24c.019-.893.111-1.186.301-1.71.704-1.935 2.335-3.238 4.699-3.29l.218.005z" fill="#fff6f6" fill-rule="nonzero"/><path d="M61.016 55.505c4.835.317 7.08 9.836-.218 9.995h-24c-4.331-.095-6.844-6.822-2.5-9.33.753-.435 1.613-.651 2.5-.67 8.072 0 16.147-.171 24.218.005zM128.997 55.504c4.356.26 6.627 7.095 2.097 9.437a5.203 5.203 0 0 1-2.296.559h-20c-4.452-.089-6.924-7.282-2.118-9.529a5.226 5.226 0 0 1 2.118-.471c6.733 0 13.467-.13 20.199.004zM119.186 96.015c1.141.132 1.321.257 1.794.486 2.747 1.333 2.99 5.083 2.585 8.833-1.949 18.035-17.599 33.62-35.685 35.46-21.853 2.222-43.72-16.118-44.079-39.279 0 0 .91-5.82 5.353-5.502 2.79.199 4.551 2.821 4.666 6.149.517 12.459 9.495 24.047 21.414 27.597 13.82 4.116 30.109-3.374 35.989-16.588 1.699-3.817 2.563-7.991 2.575-12.186 0 0 1.093-5.143 5.388-4.97z" fill="#fff6f6" fill-rule="nonzero"/><defs><linearGradient id="_Linear1" x2="1" gradientUnits="userSpaceOnUse" gradientTransform="matrix(0 -166.5 166.5 0 85 169.5)"><stop offset="0" stop-color="#f6881f"/><stop offset="1" stop-color="#ff5e0e"/></linearGradient></defs></svg>
                    </a>
                    <nav className="justify-end text-lg hidden sm:flex">
                        <Link
                            to="values"
                            href="#values"
                            smooth={true}
                            duration={500}
                            offset={-40}
                            className="links mr-16"
                            onClick={() => this.setWindowHash('values')}
                        >
                            values
                        </Link>
                        <Link
                            to="work"
                            href="#work"
                            smooth={true}
                            duration={500}
                            offset={-40}
                            className="links mr-16"
                            onClick={() => this.setWindowHash('work')}
                        >
                            work
                        </Link>
                        <Link
                            to="contact"
                            href="#contact"
                            smooth={true}
                            duration={500}
                            className="links"
                            onClick={() => this.setWindowHash('contact')}
                        >
                            contact
                        </Link>
                    </nav>
                    <div className="flex sm:hidden">
                        <button
                            type="button"
                            className="menu-button"
                            onClick={this.toggleMenu}
                        >
                            {!this.state.open ? (
                                <svg width="24" height="17">
                                    <path
                                        d="M24 8.4c0 .72-.48 1.2-1.2 1.2H1.2C.48 9.6 0 9.12 0 8.4s.48-1.2 1.2-1.2h21.6c.72 0 1.2.48 1.2 1.2zm-22.8-6h21.6c.72 0 1.2-.48 1.2-1.2S23.52 0 22.8 0H1.2C.48 0 0 .48 0 1.2s.48 1.2 1.2 1.2zm21.6 12H1.2c-.72 0-1.2.48-1.2 1.2s.48 1.2 1.2 1.2h21.6c.72 0 1.2-.48 1.2-1.2s-.48-1.2-1.2-1.2z"
                                        fill="#F6881F"
                                        fill-rule="nonzero"
                                    />
                                </svg>
                            ) : (
                                <svg width="16" height="16">
                                    <path
                                        d="M15.657 14.057a1.105 1.105 0 0 1 0 1.6c-.228.229-.457.343-.8.343s-.571-.114-.8-.343L8 9.6l-6.057 6.057c-.229.229-.457.343-.8.343s-.572-.114-.8-.343a1.105 1.105 0 0 1 0-1.6L6.4 8 .343 1.943a1.105 1.105 0 0 1 0-1.6 1.105 1.105 0 0 1 1.6 0L8 6.4 14.057.343a1.105 1.105 0 0 1 1.6 0 1.105 1.105 0 0 1 0 1.6L9.6 8l6.057 6.057z"
                                        fill="#F6881F"
                                        fill-rule="nonzero"
                                    />
                                </svg>
                            )}
                        </button>
                    </div>
                    <nav className="flex justify-between absolute mobile-links">
                        <Link
                            to="values"
                            href="#values"
                            smooth={true}
                            duration={500}
                            offset={-40}
                            className="links mr-16"
                            onClick={() => this.setWindowHash('values', true)}
                        >
                            values
                        </Link>
                        <Link
                            to="work"
                            href="#work"
                            smooth={true}
                            duration={500}
                            offset={-40}
                            className="links mr-16"
                            onClick={() => this.setWindowHash('work', true)}
                        >
                            work
                        </Link>
                        <Link
                            to="contact"
                            href="#contact"
                            smooth={true}
                            duration={500}
                            offset={-40}
                            className="links"
                            onClick={() => this.setWindowHash('contact', true)}
                        >
                            contact
                        </Link>
                    </nav>
                </div>
            </header>
        );
    }
}

Header.propTypes = {
    siteTitle: PropTypes.string
};

Header.defaultProps = {
    siteTitle: ``
};

export default Header;
